<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><a href="">BASIC </a></li>
            <li class="tab-menu__item"><a href="">Advanced Upgrade</a></li>
            <li class="tab-menu__item"><a href="">Advanced Upgrade Premium</a></li>
            <li class="tab-menu__item"><a href="">Advanced Upgrade Diamond</a></li>
            <li class="tab-menu__item"><a href="">ADDITIONAL EXAM ITEMS</a></li>
        </ul>
    </div>
    <div class="tab-menu-con">
        <div class="tab-content active">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>BASIC</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="4">Test</th>
                                    <th scope="col" colspan="2">Costs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th sope="rowgroup" rowspan="12" style="border-right: 1px solid #b9b9b9">BASIC</th>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Basic Examination</span>
                                    </th>
                                    <td class="left">Body measurement (Height, Weight), Body composition analysis(Obesity), Blood pressure</td>
                                    <td rowspan="11">
                                        Male<br>
                                        1,050,000
                                        <br>
                                        KRW
                                    </td>
                                    <td rowspan="11">
                                        Female<br>
                                        1,300,000<br>
                                        KRW
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Hearing Examination</span>
                                    </th>
                                    <td class="left">Pure tone audiometry</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Eye Examination</span>
                                    </th>
                                    <td class="left">Visual acuity, Tomometry, Fundus photography</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Cardiopulmonary<br>Function Examination</span>
                                    </th>
                                    <td class="left">Chest X-ray, ECG</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Urine, Stool<br>Examination</span>
                                    </th>
                                    <td class="left">Microscopic examination of urine sediment, Fecal occult blood test</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Blood Examination</span>
                                    </th>
                                    <td class="left">
                                        General blood test (RBC, WBC, Hb, Hct, RDW, Platelet, MCV, MCH)<br>
                                        Blood type (ABO type, Rh type)<br>
                                        Vitamine D test<br>
                                        Diabetes mellitus (Glucose, HbA1C)<br>
                                        Liver function test (T.Protein, Albumin, AST, ALT, ALP, r-GTP, TB, DB)<br>
                                        Hepatitis virus test (A/B/C type)<br>
                                        Risk factor for coronary artery disease (Homocystein, CRP, CK, Apoprotein A1, Apoprotein B)<br>
                                        Hyperlipidemia test (T.chole, HDL, LDL, TG, LDH)<br>
                                        Thyroid function test (T3, Free T4, TSH)<br>
                                        Kidney function test (BUN, Creatinine), Electrolyte test (Ca, K, Na, CI.P, T C02)<br>
                                        Gout test (Uric acid)<br>
                                        Immune serum test (RF, VDRL, HIV)<br>
                                        Pancreatic test (Amylase, lipase)<br>
                                        Tumor marker [AFP, CEA, CA19-9, CA 125 (Female), PSA&amp;free PSA (Male), SCC<br>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Gastric Cancer<br>Examination</span>
                                    </th>
                                    <td class="left">Esophagogastroduodenoscopy (EGD)</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Sonography</span>
                                    </th>
                                    <td class="left">Abdominal ultrasonography</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Selective Examination<br>(Choose 1)</span>
                                    </th>
                                    <td class="left">Thyroid ultrasonography or Low-dose chest CT</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Female Examination</span>
                                    </th>
                                    <td class="left">Liquid-based cytology (Thin Prep), Gynecological ultrasonography, HPV test, Mammography</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Other Examination</span>
                                    </th>
                                    <td class="left">Motor counseling, Bone mineral density</td>
                                </tr></tbody>
                        </table>
                    </div>
                    <p class="font-sub mt20">
                        * For women under the age of 35, we recommend a test that includes mammography if you have a family history of breast cancer.<br>
                        * All packages include a CD copy as standard.
                    </p>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>Advanced Upgrade</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Test</th>
                                <th scope="col">Costs</th></tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th rowspan="2" scope="row" class="br">UPGRADE</th>
                                    <td>Male</td>
                                    <td class="left">BASIC (Low-dose Chest CT + Thyroid ultrasonography) + Abdomen-Pelvis CT, Colonoscopy under sedation</td>
                                    <td>1,800,000 KRW</td>
                                </tr>
                                <tr>
                                    <td>Female</td>
                                    <td class="left">BASIC (Low-dose Chest CT + Thyroid ultrasonography) + Breast ultrasonography, Abdominen-Pelvis CT, Colonoscopy under sedation</td>
                                    <td>2,280.000 KRW</td>
                                </tr>
                                <tr>
                                    <th rowspan="2" scope="row" class="br">UPGRADE PLUS</th>
                                    <td>Male</td>
                                    <td class="left">UPGRADE + Carotid ultrasonography, Cardiac(Coronary artery_3D)CT, Brain MRI &amp; MR Angio</td>
                                    <td>3,800,000 KRW</td>
                                </tr>
                                <tr>
                                    <td>Female</td>
                                    <td class="left">UPGRADE + Carotid ultrasonography, Cardiac(Coronary artery_3D)CT, Brain MRI &amp; MR Angio</td>
                                    <td>4,250,000 KRW</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table table-border02 table-bg01">
                        <table>
                            <caption>Advanced Upgrade Premium</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Test</th>
                                    <th scope="col">Costs</th></tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">PREMIUM</th>
                                    <td>Male</td>
                                    <td class="left">UPGRADE PLUS + Brain &amp; Whole-body PET-CT, Cardiac ultrasonography, Male hormone test, 1 night stay in the VIP room</td>
                                    <td>6,200,000 KRW</td>
                                </tr>					
                                <tr>	
                                    <td>Female</td>
                                    <td class="left">UPGRADE PLUS + Brain &amp; Whole-body PET-CT, Cardiac ultrasonography, Female hormone test, 1 night stay in the VIP room</td>
                                    <td>6,700,000 KRW</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>Advanced Upgrade Diamond</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Test</th>
                                    <th scope="col">Costs</th></tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">DIAMOND</th>
                                    <td>Male</td>
                                    <td class="left">PREMIUM + Cervical MRI + Lumbar MRI + 1 night stay in the VIP room</td>
                                    <td>7,750,000 KRW</td>
                                </tr>					
                                <tr>	
                                    <td>Female</td>
                                    <td class="left">PREMIUM + Cervical MRI + Lumbar MRI + 1 night stay in the VIP room</td>
                                    <td>8,200,000 KRW</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>ADDITIONAL EXAM ITEMS</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 20%;">
                                <col style="width: auto">
                                <col style="width: 30%;">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="4">Exam Items</th>
                                    <th scope="col">Costs</th></tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup" rowspan="6" class="br">GITract Exam</th>
                                    <td rowspan="4" class="br">Endoscopy</td>
                                    <td class="left"> Sedation for Esophagogastroduodenoscopy (EGD)</td>
                                    <td rowspan="4">*Removal of polyp &amp; biopsy may be required which causes additional costs.</td>
                                    <td>120,000</td>
                                </tr>		
                                <tr>
                                    <td class="left">Sedation for Colonoscopy</td>						
                                    <td>120,000</td>
                                </tr>
                                <tr>
                                    <td class="left">Sedation for Both EGD &amp; Colonoscopy</td>						
                                    <td>150,000</td>
                                </tr>
                                <tr>
                                    <td class="left">Colonoscopy</td>						
                                    <td>260,000</td>
                                </tr>
                                <tr>
                                    <td>Ultrasonography</td>
                                    <td class="left">Abdomen ultrasonography</td>						
                                    <td></td>
                                    <td>250,000</td>
                                </tr>
                                <tr>
                                    <td>CT</td>
                                    <td class="left">Abdomen-Pelvis CT</td>				
                                    <td>Use of contrast agents</td>
                                    <td>370,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="3">Brain Exam</th>
                                    <td rowspan="5" class="br">MRI</td>
                                    <td class="left">Brain MRI</td>						
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <td class="left">Brain MRA</td>						
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <td class="left">Brain MRI &amp; MR Angio</td>						
                                    <td></td>
                                    <td>1,500,000</td>
                                </tr>
                                <tr>
                                    <th rowspan="2">Cervical-Lumbar Exam</th>						
                                    <td class="left">C-Spine MRI</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <td class="left">L-Spine MRI</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="3" class="br">Heart Exam</th>
                                    <td rowspan="2" class="br">Ultrasonography</td>
                                    <td class="left">Ecocardiography</td>
                                    <td></td>
                                    <td>300,000</td>
                                </tr>
                                <tr>
                                    <td class="left">Carotid ultrasonography</td>
                                    <td></td>
                                    <td>220,000</td>
                                </tr>
                                <tr>
                                    <td>CT</td>
                                    <td class="left">Cardiac (Coronary artery_3D) CT</td>
                                    <td>Use of contrast agents</td>
                                    <td>400,000</td>
                                </tr>
                                <tr>
                                    <th colspan="3">Brain &amp; Whole-body PET-CT</th>
                                    <td>Use of radioactive agents</td>
                                    <td>1,700,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">Cervical-Lumbar Exam</th>
                                    <td rowspan="3" class="br">CT</td>
                                    <td class="left">C-Spine CT</td>
                                    <td></td>
                                    <td>230,000</td>
                                </tr>
                                <tr>
                                    <td class="left">L-Spine CT</td>
                                    <td></td>
                                    <td>230,000</td>
                                </tr>
                                <tr>
                                    <th>Chest Exam</th>
                                    <td class="left">Low-dose Chest CT</td>
                                    <td></td>
                                    <td>220,000</td>
                                </tr>
                                <tr>
                                    <th colspan="3">Thyroid ultrasonography</th>
                                    <td></td>
                                    <td>220,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">male Exam</th>
                                    <td>Prostate</td>
                                    <td class="left">Prostate Ultrasonography</td>
                                    <td></td>
                                    <td>230,000</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="left">Male hormone test</td>
                                    <td></td>
                                    <td>180,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">Female Exam</th>
                                    <td>Breast</td>
                                    <td class="left">Breast ultrasonography</td>
                                    <td></td>
                                    <td>260,000</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="left">Female hormone test</td>
                                    <td></td>
                                    <td>200,000</td>
                                </tr>
                                <tr>
                                    <th>Other</th>
                                    <td>1-night stay health check-up</td>
                                    <td class="left">VIP room</td>
                                    <td>No discount</td>
                                    <td>500,000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
</template>
<script>
export default {

}
</script>